const s = 'https://fonts.googleapis.com/css2?family='
const e = '&display=swap'

export const gFontUrls = {
  ballyThrill: 'https://on.ballybet.ca/api/content/common/fonts/BallyThrill/BallyThrill.css',
  nunitoSans: `${s}Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000${e}`,
  fredoka: `${s}Fredoka:wght@300..700${e}`,
  kumbhSans: `${s}Kumbh+Sans:wght@100..900${e}`,
  outfit: `${s}Outfit:wght@100..900${e}`,
  eBGaramond: `${s}EB+Garamond:ital,wght@0,400..800;1,400..800${e}`,
  workSans: `${s}Work+Sans:ital,wght@0,100..900;1,100..900${e}`
}

export const ballyFonts = ` 
  @font-face {
    font-family: bally-thrill;
    src:url("https://cdn.inx01.gamesysgames.com/common/fonts/BallyThrill/BallyThrill_CdXBd.woff") format("woff");
    unicode-range: U+000-5FF;
    font-display: swap;
    font-weight: 800;
  }
    

  @font-face{
    font-family: bally-thrill;
    src:url("https://cdn.inx01.gamesysgames.com/common/fonts/BallyThrill/BallyThrill_Rg.woff") format("woff");
    unicode-range: U+000-5FF;
    font-display: swap;
    font-weight: 400;
  }

  @font-face {
    font-family: bally-thrill;
    src:url("https://cdn.inx01.gamesysgames.com/common/fonts/BallyThrill/BallyThrill_Bd.woff") format("woff");
    unicode-range: U+000-5FF;
    font-display: swap;
    font-weight: 700;
  }
`
